import * as React from 'react';
import Helmet from 'react-helmet';
import { logoutUnAuthenticat } from '../actions/auth';
import { connect } from 'react-redux';

interface Props {
  isAuthenticated: boolean;
  history?: any;
  dispatch: any;
}
class View extends React.Component<Props> {

  componentDidMount(): void {
    this.logOut();
  }

  async logOut() {
    console.log('Login here ------------');
    await this.props.dispatch(logoutUnAuthenticat((resData) => {
      console.log('resDataresData', resData);
      window.location.href = '/login';
    }));
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Error</title>
        </Helmet>
        <section className="section">
          <div className="container content">
            <div className="columns is-centered">
              <div className="column is-two-thirds">
                <h1>Page Not Found</h1>
                <div onClick={() => window.location.href = '/'} key="home">Click here</div> to return to the homepage.
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(View);

